// extracted by mini-css-extract-plugin
module.exports = {"card_wrapper":"work-group-two-three_card_wrapper__3W3mr"};